module.exports = __webpack_public_path__ + "static/media/successImage.50cca3dd.svg";